function filterOsNames() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./filter-os-names.html'),
  };
}

export { filterOsNames };
